import { render, staticRenderFns } from "./tabsMix2.vue?vue&type=template&id=225ccbc4&scoped=true"
import script from "./tabsMix2.vue?vue&type=script&lang=js"
export * from "./tabsMix2.vue?vue&type=script&lang=js"
import style0 from "./tabsMix2.vue?vue&type=style&index=0&id=225ccbc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ccbc4",
  null
  
)

export default component.exports